import { ReactNode, useEffect, useState } from 'react';
import { Drawer } from '@mui/material';
import { DASHBOARD_HEADER_HEIGHT_PX } from '../../constants';

const COLLAPSED_WIDTH = 460;

const RightPanel = ({
  children,
  isOpened,
  isExpanded,
}: {
  children: ReactNode;
  isOpened: boolean;
  isExpanded: boolean;
}) => {
  const sideMenuRef = window.document.getElementById('sidebar-menu');
  const [sideMenuWidth, setSideMenuWidth] = useState(0);
  const width = isExpanded ? `calc(100vw - ${sideMenuWidth}px + 1px)` : COLLAPSED_WIDTH + 'px';

  useEffect(() => {
    if (sideMenuRef) {
      const observer = new ResizeObserver(() => {
        if (sideMenuRef.clientWidth) {
          setSideMenuWidth(sideMenuRef.clientWidth);
        }
      });
      observer.observe(sideMenuRef);
    }
  }, [sideMenuRef]);

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={isOpened}
      PaperProps={{
        sx: {
          top: DASHBOARD_HEADER_HEIGHT_PX,
          width,
          boxShadow: isExpanded ? 0 : 1,
          clipPath: `inset(0 -30px -30px -30px)`, // to remove the shadow only from the top (that is aligned to the header)
          height: `calc(100vh - ${DASHBOARD_HEADER_HEIGHT_PX})`,
          transition: 'all .4s ease!important', //important is needed to override inline styling from MUI
          zIndex: 1001, //Careful when changing this value - make sure it is above: "CanvasToolbar", table's "stickyHeaderStyles", Canvas "Zero State Panel"
          overflow: 'hidden',
        },
      }}
    >
      {children}
    </Drawer>
  );
};

export default RightPanel;
